export enum CoinTransactionState {
  Started = 'Started',
  Running = 'Running',
  Finished = 'Finished',
  Published = 'Published',
  Failed = 'Failed',
  Cancelled = 'Cancelled'
}
